import React from 'react';
import { Link } from 'react-router-dom';
import { Settings, Phone, Mail, MapPin, Facebook, Twitter, Instagram, Youtube, CreditCard, Shield, Truck, RefreshCw } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white mt-16">
      {/* Trust Badges */}
      <div className="border-b border-slate-800">
        <div className="container mx-auto py-8 px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center">
                <Truck className="h-6 w-6 text-orange-400" />
              </div>
              <div>
                <h4 className="font-semibold">Hızlı Kargo</h4>
                <p className="text-sm text-slate-400">1-3 iş günü</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center">
                <Shield className="h-6 w-6 text-orange-400" />
              </div>
              <div>
                <h4 className="font-semibold">Güvenli Ödeme</h4>
                <p className="text-sm text-slate-400">256-bit SSL</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center">
                <RefreshCw className="h-6 w-6 text-orange-400" />
              </div>
              <div>
                <h4 className="font-semibold">Kolay İade</h4>
                <p className="text-sm text-slate-400">14 gün içinde</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center">
                <CreditCard className="h-6 w-6 text-orange-400" />
              </div>
              <div>
                <h4 className="font-semibold">Taksit İmkanı</h4>
                <p className="text-sm text-slate-400">12 aya kadar</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto py-12 px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <Settings className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="font-bold text-xl">Pazarlo</h3>
              </div>
            </div>
            <p className="text-slate-400 text-sm mb-4">
              Türkiye'nin en büyük oto yedek parça pazarı. 
              Güvenilir satıcılar, kaliteli ürünler.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-bold text-lg mb-4">Kategoriler</h4>
            <ul className="space-y-2 text-slate-400">
              <li><Link to="/products?category=motor-parcalari" className="hover:text-orange-400 transition-colors">Oto Yedek Parça</Link></li>
              <li><Link to="/products?category=turbo-sarj" className="hover:text-orange-400 transition-colors">Turbo & Şarj</Link></li>
              <li><Link to="/products?category=piston-segman" className="hover:text-orange-400 transition-colors">Piston & Segman</Link></li>
              <li><Link to="/products?category=filtreler" className="hover:text-orange-400 transition-colors">Filtreler</Link></li>
              <li><Link to="/products?category=triger-seti" className="hover:text-orange-400 transition-colors">Triger Seti</Link></li>
              <li><Link to="/products" className="hover:text-orange-400 transition-colors">Tüm Ürünler</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-bold text-lg mb-4">Müşteri Hizmetleri</h4>
            <ul className="space-y-2 text-slate-400">
              <li><Link to="/help" className="hover:text-orange-400 transition-colors">Yardım Merkezi</Link></li>
              <li><Link to="/orders" className="hover:text-orange-400 transition-colors">Sipariş Takibi</Link></li>
              <li><Link to="/returns" className="hover:text-orange-400 transition-colors">İade ve Değişim</Link></li>
              <li><Link to="/seller" className="hover:text-orange-400 transition-colors">Satıcı Ol</Link></li>
              <li><Link to="/contact" className="hover:text-orange-400 transition-colors">İletişim</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">İletişim</h4>
            <ul className="space-y-3 text-slate-400">
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-orange-400" />
                <span>0850 123 45 67</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-orange-400" />
                <span>destek@pazarlo.com</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-orange-400 mt-1" />
                <span>İstanbul, Türkiye</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto py-6 px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © 2024 Pazarlo. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-4 text-sm text-slate-400">
              <Link to="/privacy" className="hover:text-orange-400 transition-colors">Gizlilik Politikası</Link>
              <span>|</span>
              <Link to="/terms" className="hover:text-orange-400 transition-colors">Kullanım Koşulları</Link>
              <span>|</span>
              <Link to="/cookies" className="hover:text-orange-400 transition-colors">Çerez Politikası</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
